import { FC } from "react";
import { UserCircle2 } from "lucide-react";

export interface ImpersonationBannerUser {
	firstName: string;
	lastName: string;
	avatarUrl?: string | null;
}

interface Props {
	impersonatedBy: ImpersonationBannerUser;
	variant?: "default" | "compact";
}

const isSafeImageUrl = (url: string | null | undefined): url is string =>
	!!url && /^https?:\/\//i.test(url);

const ImpersonationBanner: FC<Props> = ({
	impersonatedBy,
	variant = "default"
}) => {
	const fullName =
		`${impersonatedBy.firstName} ${impersonatedBy.lastName}`.trim();

	if (variant === "compact") {
		return (
			<div
				data-testid="impersonation-banner"
				data-variant="compact"
				className="inline-flex items-center gap-1.5 rounded-md bg-amber-50 px-2 py-0.5 text-xs text-amber-900 border border-amber-200"
			>
				<UserCircle2 className="h-3 w-3" aria-hidden="true" />
				<span>Impersonated by {fullName}</span>
			</div>
		);
	}

	return (
		<div
			data-testid="impersonation-banner"
			data-variant="default"
			className="flex items-center gap-2 rounded-t-xl bg-amber-50 px-4 py-2 text-sm text-amber-900 border-b border-amber-200"
		>
			{isSafeImageUrl(impersonatedBy.avatarUrl) ? (
				<img
					src={impersonatedBy.avatarUrl}
					alt=""
					className="h-5 w-5 rounded-full"
				/>
			) : (
				<UserCircle2 className="h-5 w-5" aria-hidden="true" />
			)}
			<span>
				Impersonated by <span className="font-medium">{fullName}</span>
			</span>
		</div>
	);
};

export default ImpersonationBanner;
